import { ElementRef, OnInit, OnDestroy, NgZone, HostListener } from '@angular/core';
import { MediaType } from './media.type';
import { Component, Input } from '@angular/core';
import { MediaSrc } from './media-src.type';

@Component({
  selector: 'vm-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss'],
})
export class MediaComponent implements OnInit, OnDestroy {
  @Input() aspectRatio: string | '1:1' | '2:1' | '16:9';

  @Input() mediaType: string | 'video' | 'image' = 'image';
  @Input() altText = 'media';
  @Input() lazyLoad = true;
  @Input() lazyThreshold = 0.05;
  @Input() loadOnScroll = true;
  @Input() visible = false;
  @Input() multiple = false;
  @Input() containMedia = true;
  @Input() containMediaScaleDown = false;
  @Input() coverMedia = false;
  @Input() exclude = [];
  @Input() mediaSrc: MediaSrc;

  @Input() set source(src: string | MediaSrc) {
    if (typeof src === 'string') {
      this.src = src;
      if (src?.toLowerCase().endsWith('mp3')) {
        this.mediaType = 'video';
      }
    } else {
      this.mediaSrc = src;
      if (src?.default?.toLowerCase().endsWith('mp3')) {
        this.mediaType = 'video';
      }
    }
  }

  src: string;
  breakpoints: MediaSrc;
  public mediaTypes = MediaType;
  private intersectionObserver?: IntersectionObserver;

  constructor(private element: ElementRef, private ngZone: NgZone) {}

  hasIntersectionObserver() {
    const hasIntersectionObserver = 'IntersectionObserver' in window; // no fallback or polyfill, old browsers are shown media immediately
    return hasIntersectionObserver;
  }
  @HostListener('document:scroll', [])
  onScroll(): void {
    if (this.loadOnScroll) {
      this.visible = true;
    }
  }

  ngOnInit() {
    if (!this.lazyLoad || (!this.hasIntersectionObserver() && !this.loadOnScroll)) {
      this.visible = true;
    } else if (this.hasIntersectionObserver()) {
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry: IntersectionObserverEntry) => {
            if (entry.isIntersecting) {
              this.visible = true;
            }
          });
        },
        { threshold: this.lazyThreshold }
      );
      this.intersectionObserver.observe(this.element.nativeElement);
    }
  }

  ngOnDestroy() {
    if (this.intersectionObserver) {
      this.intersectionObserver.unobserve(this.element.nativeElement);
      this.intersectionObserver.disconnect();
    }
  }
}
